// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_5L9","cls2":"ArticlesFilters-cls2_9yf ArticlesFilters-cls1_5L9"};